import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { updateNationalCode } from 'services/auth_national'
import posthog from 'posthog-js'

export default function useAddNationalCode(refetch: () => void) {
    const { mutate } = useMutation({
        mutationFn: (nationalCode: string) => {
            return updateNationalCode(nationalCode)
        },
        onSuccess: () => {
            // National code itself is PII — capture the conversion, not the value.
            posthog.capture('national_code_verified')
            toast.success('کد ملی با موفقیت تایید شد')
            refetch()
        },
        onError: () => {
            posthog.capture('national_code_verification_failed')
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
